import { type ExWindow } from '@ve/types';

declare let window: ExWindow;

const MAIN_PAGE_URL = '/';

const LOGO_SELECTOR = '.picture-travelata-logo, .headerTravelataLogo';

const PRIMARY_MOUSE_BUTTON = 0;

const isPlainLeftClick = (event: MouseEvent): boolean =>
    event.button === PRIMARY_MOUSE_BUTTON &&
    !event.metaKey &&
    !event.ctrlKey &&
    !event.shiftKey &&
    !event.altKey;

export const initAnniversaryLogoClick = (): void => {
    document.addEventListener(
        'click',
        (event) => {
            if (!window.appConfig?.anniversary15Logo) {
                return;
            }

            const eventTarget = event.target;

            if (!(eventTarget instanceof Element) || !eventTarget.closest(LOGO_SELECTOR)) {
                return;
            }

            if (!isPlainLeftClick(event)) {
                return;
            }

            event.preventDefault();
            event.stopPropagation();
            window.location.href = MAIN_PAGE_URL;
        },
        true,
    );
};
